import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LocationState {
  savedAddresses?: string;
  savedPickup?: string;
}

const initialState: LocationState = {
  savedPickup: localStorage.getItem('pickup') || '',
  savedAddresses: localStorage.getItem('address') || '',
};

export const SaveAddressesSlice = createSlice({
  name: 'saveAddresses',
  initialState,
  reducers: {
    savePickup: (state, action: PayloadAction<LocationState>) => {
      state.savedPickup = action.payload.savedPickup;
      localStorage.setItem('pickup', action.payload.savedPickup!);
    },
    saveAddresses: (state, action: PayloadAction<LocationState>) => {
      state.savedAddresses = action.payload.savedAddresses;
      localStorage.setItem('address', action.payload.savedAddresses!);
    },
    removeAddresses: state => {
      state.savedAddresses = '';
      localStorage.removeItem('address');
    },
    removePickup: state => {
      state.savedPickup = '';
      localStorage.removeItem('pickup');
    },
  },
});

export const { saveAddresses, removeAddresses, savePickup, removePickup } =
  SaveAddressesSlice.actions;
export default SaveAddressesSlice.reducer;
